import React from 'react';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import servicePeople from 'services/people';

/**
 * @typedef {Object} UseUpdateIsOptInConfirmedMutationVariables
 * @property {number} personId
 * @property {boolean} value
 */

/** @typedef {import('services/people').UpdateIsOptInConfirmedResponse} UpdateIsOptInConfirmedResponse */

/** @typedef {Omit<UseMutationOptions<UpdateIsOptInConfirmedResponse, Error, UseUpdateIsOptInConfirmedMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseUpdateIsOptInConfirmedMutationOptions */

/**
 * Update is opt in confirmed mutation.
 * @param {UseUpdateIsOptInConfirmedMutationOptions} [options={}]
 */
export const useUpdateIsOptInConfirmedMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['update-is-opt-in-confirmed'],
        /** @param {UseUpdateIsOptInConfirmedMutationVariables} props */
        mutationFn: ({ personId, value }) => servicePeople.updateIsOptInConfirmed(personId, value)
    });
};

/**
 * @param {React.ComponentType} Component
 * @param {UseUpdateIsOptInConfirmedMutationOptions} [options]
 * @returns {(props: any) => React.ReactElement}
 */
export const withUpdateIsOptInConfirmedMutation = (Component, options) => props => {
    const updateIsOptInConfirmedMutation = useUpdateIsOptInConfirmedMutation(options);
    return <Component {...props} updateIsOptInConfirmedMutation={updateIsOptInConfirmedMutation} />;
};
